(function () {
  'use strict';

  if (window.__codexMobileCheckoutLoaded) return;
  window.__codexMobileCheckoutLoaded = true;
  if (window.location.hostname !== 'oukitelpower.com') return;

  var MOBILE_QUERY = '(max-width: 767px)';
  var PROMO_TEXT = /Triple Your Prime Day Rewards|Unlock 3 Ways|PRIME8/i;
  var SIDE_PROMO_TEXT = /Lock In Your Prime Day Savings|Prime Day Savings/i;
  var scanCount = 0;
  var queuedRun = null;

  function isMobileProduct() {
    return window.matchMedia &&
      window.matchMedia(MOBILE_QUERY).matches &&
      document.body &&
      document.body.classList.contains('template-product');
  }

  function fixedAncestor(element) {
    var node = element;
    while (node && node !== document.body) {
      if (window.getComputedStyle(node).position === 'fixed') return node;
      node = node.parentElement;
    }
    return null;
  }

  // function hideElement(element) {
  //   if (!element) return;
  //   element.style.setProperty('display', 'none', 'important');
  //   element.style.setProperty('visibility', 'hidden', 'important');
  //   element.style.setProperty('pointer-events', 'none', 'important');
  //   element.setAttribute('aria-hidden', 'true');
  // }

  function unlockScroll() {
    document.body.classList.remove('klaviyo-prevent-body-scrolling');
    document.body.style.removeProperty('overflow');
    document.body.style.removeProperty('position');
    document.documentElement.style.removeProperty('overflow');
  }

  function suppressObstructivePromo() {
    if (!isMobileProduct()) return;
    var forms = Array.prototype.slice.call(document.querySelectorAll('form.klaviyo-form'));
    forms.forEach(function (form) {
      var overlay = fixedAncestor(form);
      if (!overlay || !PROMO_TEXT.test(overlay.innerText || '')) return;
      var rect = overlay.getBoundingClientRect();
      var obstructive = rect.width >= window.innerWidth * 0.65 && rect.height >= window.innerHeight * 0.45;
      if (!obstructive) return;
      var close = overlay.querySelector('button.klaviyo-close-form, button[aria-label*="Close"], button[aria-label*="close"]');
      // if (close) close.click();
      // hideElement(overlay);
      unlockScroll();
      document.body.classList.add('codex-mobile-product-popup-muted');
    });
    Array.prototype.slice.call(document.querySelectorAll('[class*="kl-teaser"], [class*="Teaser-pointer"]')).forEach(hideElement);
  }

  function markSidePromos() {
    if (!isMobileProduct() || scanCount > 10) return;
    scanCount += 1;
    Array.prototype.slice.call(document.querySelectorAll('body *')).forEach(function (element) {
      if (element.dataset && element.dataset.codexMobilePromoTab) return;
      var text = (element.innerText || '').replace(/\s+/g, ' ').trim();
      if (!text || !SIDE_PROMO_TEXT.test(text)) return;
      var rect = element.getBoundingClientRect();
      var style = window.getComputedStyle(element);
      var fixedLike = /fixed|sticky|absolute/.test(style.position);
      var tabShape = rect.height > 100 && rect.width < 130;
      var rightSide = rect.left > window.innerWidth * 0.55 || rect.right > window.innerWidth - 12;
      if (fixedLike && tabShape && rightSide) element.setAttribute('data-codex-mobile-promo-tab', 'hidden');
    });
  }

  function syncCartDrawerState() {
    if (!document.body) return;
    var open = !!document.querySelector('#CartDrawer.drawer--is-open, cart-drawer.active, .drawer--is-open');
    document.body.classList.toggle('codex-cart-drawer-open', open);
  }

  function run() {
    suppressObstructivePromo();
    markSidePromos();
    syncCartDrawerState();
  }

  function queueRun() {
    if (queuedRun) return;
    queuedRun = window.setTimeout(function () {
      queuedRun = null;
      run();
    }, 250);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  [500, 1500, 3000, 6000, 10000, 15000].forEach(function (delay) {
    window.setTimeout(run, delay);
  });

  document.addEventListener('click', function () {
    window.setTimeout(syncCartDrawerState, 100);
    window.setTimeout(syncCartDrawerState, 600);
  }, true);

  var observer = new MutationObserver(queueRun);
  observer.observe(document.documentElement, { childList: true, subtree: true });
  window.setTimeout(function () { observer.disconnect(); }, 20000);
})();
